import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router";
import Volumetric from './pages/Volumetric';
import ShipmentRateCalc from './pages/ShipmentRateCalc';
import Career from './pages/Career';
import About from './pages/About'
import Apply from './pages/Apply';
import ScrollToTop from './component/ScrollToTop';
import Features from './pages/Features';
import Pacex from './pages/Pacex';
import Layout from './Layout';
import Tracking from './pages/Tracking';
import TrackingNew from './pages/TrackingNew';
import Videsh from './pages/ParcelVidesh'
import CourierPartners from './pages/CourierPartners'
import ChannelIntegration from './pages/ChannelIntegration'
import ContactUs from './pages/ContactUs'
import Pricing from './pages/Pricing';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import RefundCancellation from './pages/RefundCancellation';
import GeneralDataProtectionRegulation from './pages/GeneralDataProtectionRegulation';
import PolicyCompliance from './pages/PolicyCompliance';
import CustomTracking from './pages/CustomTracking';
const root = document.getElementById("root");
  ReactDOM.createRoot(root).render(
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<><App  /> </>} />  
          <Route path='/volumetric' element={<><Volumetric  /> </>} /> 
          <Route path='/shipmentrate' element={<><ShipmentRateCalc  /> </>} /> 
          <Route path='/career' element={<><Career  /> </>} /> 
          <Route path='/about' element={<><About  /> </>} /> 
          <Route path='/apply' element={<><Apply  /> </>} /> 
          <Route path='/pacex' element={<><Pacex  /> </>} /> 
          <Route path='/contact-us' element={<><ContactUs  /> </>} /> 
          <Route path='/features' element={<><Features  /> </>} /> 
          <Route path='/tracking_one' element={<><Tracking  /> </>} /> 
          <Route path='/tracking' element={<><TrackingNew  /> </>} /> 
          <Route path='/pricing' element={<><Pricing  /> </>} /> 
          <Route path='/parcel-videsh' element={<><Videsh  /> </>} /> 
          <Route path='/courier-partners' element={<><CourierPartners  /> </>} /> 
          <Route path='/channel-integration' element={<><ChannelIntegration  /> </>} /> 
          <Route path='/privacy' element={<><Privacy  /> </>} /> 
          <Route path='/terms' element={<><Terms  /> </>} /> 
          <Route path='/policy-compliance' element={<><PolicyCompliance  /> </>} /> 
          <Route path='/general-data' element={<><GeneralDataProtectionRegulation  /> </>} /> 
          <Route path='/refund-cancellation' element={<><RefundCancellation  /> </>} /> 
          <Route path='/custom-tracking' element={<><CustomTracking  /> </>} /> 
        </Route>
      </Routes>
    </BrowserRouter>  
  );

reportWebVitals();
